import * as React from "react";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as sanitizeHtml from "sanitize-html-react";

class StaticHtmlContent extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.StaticHtmlContent.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {

        let { content, classname, customAllowedTags, customAllowedAttributes } = this.props;
        let allowedTagsList = ['h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
            'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'hr', 'br', 'div', 'dl', 'dt', 'dd',
            'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre'];
        let allowedAttributesList = {
            'a': ['class', 'href', 'target'],
            'h2': ['class', 'id']
        };
        let allowedSchemes = ['http', 'https', 'ftp', 'mailto', 'tel'];

        if (customAllowedTags) {
            allowedTagsList = allowedTagsList.concat(customAllowedTags);
        }
        if (customAllowedAttributes) {
            allowedAttributesList = { ...allowedAttributesList, ...customAllowedAttributes };
        }
        //debugger;
        var santitizedContent = window.sanitizeHtml(content, {
            allowedTags: allowedTagsList,
            allowedAttributes: allowedAttributesList,
            allowedSchemes: allowedSchemes
        });

        return (
            <React.Fragment>
                {content && <div className={classname ? classname: null} dangerouslySetInnerHTML={{ __html: santitizedContent }}></div>}
            </React.Fragment>
        );
    }
}

export default StaticHtmlContent;